module.exports = __webpack_public_path__ + "9ec9caaadcac5f1e1f54bd630ebbbfc0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-29.png
// module id = 2538
// module chunks = 0